import React from "react";
import { Section } from "components/section";
import { FillImage } from "components/images";
import { Diptych, DiptychColumn } from "ui/diptych";
import { Button } from "ui/button";
import composableCdpImage from "../../../../public/assets/shared-illustrations/composable-cdp.png";
import secondDiptychImage from "../../../../public/assets/solutions/data/diptych-2.png";
import thirdDiptychImage from "../../../../public/assets/solutions/data/diptych-3.png";
import fourthDiptychImage from "../../../../public/assets/solutions/data/diptych-4.png";

export function DataDiptychs() {
  return (
    <Section>
      <DiptychColumn>
        <Diptych
          direction="right"
          title="Your warehouse as a source of truth"
          description="Hightouch never stores any of your data. We believe you should maintain control and take advantage of your existing architecture. Here’s how your data passes through Hightouch."
          actions={
            <Button hasRightChevron href="/docs/getting-started/concepts" target="_blank">
              Our core concepts
            </Button>
          }
          media={
            <FillImage
              src={composableCdpImage}
              alt="Flow between the the data warehouse, Hightouch as a Composable CDP, and user's integration ecosystem."
            />
          }
        />

        <Diptych
          direction="left"
          title="Integrated with your engineering tools and workflows"
          description="Hightouch integrates with dbt, Looker, and other essential platforms. Our Git Sync feature enables version control and facilitates collaboration across your data team. Advanced orchestration and observability features enhance your data workflows and provide greater control over your data processes."
          actions={
            // @TODO @Taylor: Link to extensions once it's re-branded.
            <Button hasRightChevron href="/integrations">
              Explore our integrations
            </Button>
          }
          media={
            <FillImage
              src={secondDiptychImage}
              alt="Abstract illustration of Hightouch's logo at the center with the logos of various Hightouch extension toolings floating around it such as Datadog, Fivetran, Sigma, dbt, and Looker."
            />
          }
        />

        <Diptych
          direction="right"
          title="Security and compliance by design"
          description="With SOC 2, HIPAA, and GDPR compliance, Hightouch ensures top-tier security by operating directly in your data warehouse without storing data, while providing granular access controls and robust data governance."
          actions={
            <Button hasRightChevron href="/platform/security">
              Read more about data security
            </Button>
          }
          media={
            <FillImage
              src={thirdDiptychImage}
              alt="Abstract illustration highlighting SOC 2 Type 2, AES-256, HIPAA, and GDPR security standards."
            />
          }
        />

        <Diptych
          direction="left"
          title="Empower teams across your organization"
          description="Hightouch's intuitive interface enables business teams to access and utilize data independently, while automated pipelines free up your data team to focus on strategic initiatives, fostering collaboration and driving innovation across the organization."
          actions={
            <Button hasRightChevron href="/platform/customer-studio">
              Learn more about Customer Studio
            </Button>
          }
          media={
            <FillImage
              src={fourthDiptychImage}
              alt="Abstract illustration of custom audiences getting activated through Hightouch."
            />
          }
        />
      </DiptychColumn>
    </Section>
  );
}
